<template>
  <div
    class="route-progress"
    :class="{
      'route-progress--visible': visible,
      'route-progress--finishing': finishing
    }"
    :style="{ transform: `scaleX(${progress / 100})` }"
  />
</template>

<script setup>
import { ref, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const progress = ref(0)
const visible = ref(false)
const finishing = ref(false)

let interval = null
let hideTimeout = null

function start() {
  clearInterval(interval)
  clearTimeout(hideTimeout)
  progress.value = 0
  finishing.value = false
  visible.value = true

  interval = setInterval(() => {
    if (progress.value < 65) progress.value += 7
    else if (progress.value < 82) progress.value += 2
    else if (progress.value < 92) progress.value += 0.5
  }, 60)
}

function finish() {
  clearInterval(interval)
  finishing.value = true
  progress.value = 100

  hideTimeout = setTimeout(() => {
    visible.value = false
    finishing.value = false
    progress.value = 0
  }, 500)
}

const removeBeforeEach = router.beforeEach(() => start())
const removeAfterEach = router.afterEach(() => finish())

onUnmounted(() => {
  removeBeforeEach()
  removeAfterEach()
  clearInterval(interval)
  clearTimeout(hideTimeout)
})
</script>

<style scoped>
.route-progress {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  transform-origin: left center;
  transform: scaleX(0);
  z-index: 9999;
  opacity: 0;
  pointer-events: none;
  background: linear-gradient(90deg, var(--primary, #0ea5e9), #38bdf8, var(--primary, #0ea5e9));
  box-shadow: 0 0 12px var(--primary, #0ea5e9), 0 0 4px rgba(56, 189, 248, 0.6);
  border-radius: 0 2px 2px 0;
  transition: transform 0.18s ease;
}

.route-progress--visible {
  opacity: 1;
}

.route-progress--finishing {
  transition: transform 0.12s ease, opacity 0.4s ease 0.15s;
  opacity: 0;
}
</style>
